const Map = ({
  values,
  children,
}: {
  values: string[];
  children: (value: string) => React.ReactNode;
}) => {
  return values.map((value) => children(value));
};
export default Map;
